import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { INews } from "src/app/models/news.model";


@Component({
  selector: "app-confirm-window",
  templateUrl: "./confirm-window.component.html",
  styleUrls: ["./confirm-window.component.scss"],
})
export class ConfirmWindowComponent implements OnInit {
  itemTitle: string;

  @Input() item: INews;
  
  @Output() confirmationResult = new EventEmitter<boolean>();

  constructor(public modal: NgbActiveModal) {
    this.itemTitle = "";
  }

  ngOnInit() {
      this.itemTitle = this.item?.title;
  }

  cancel() {
    this.confirmationResult.emit(false);
    this.modal.close();
  }

  confirm() {
    this.confirmationResult.emit(true);
    this.modal.close();
  }
}
